import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const WorkbooksDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment WorkbooksDisplayGridRowDataFragment on Workbook {
  ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
